import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import FGCurrentForecastTracker from "./FGCurrentForecastTracker";
import FGPastForecastTracker from "./FGPastForecastTracker";
import { setActiveDataElement } from "../../../redux/userSlice";


const FGDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("FG Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/fg-inventory-dashboard"},
                { title: "Dashboard" },
              ]}
              title="FG Inventory Upload Dashboard"
            />
            <div className="container">
                {/* top table */}
             <FGCurrentForecastTracker />
             {/* bottom table */}
             <FGPastForecastTracker />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default FGDashboard;
